import { render, staticRenderFns } from "./frost.vue?vue&type=template&id=2ac0786d&scoped=true&"
import script from "./frost.vue?vue&type=script&lang=js&"
export * from "./frost.vue?vue&type=script&lang=js&"
import style0 from "./frost.vue?vue&type=style&index=0&id=2ac0786d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac0786d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac0786d')) {
      api.createRecord('2ac0786d', component.options)
    } else {
      api.reload('2ac0786d', component.options)
    }
    module.hot.accept("./frost.vue?vue&type=template&id=2ac0786d&scoped=true&", function () {
      api.rerender('2ac0786d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/frost.vue"
export default component.exports